import { z } from 'zod'

export const labelingStudioSearchSchema = z.object({
  modelId: z.string().optional(),
})

export type LabelingStudioSearchParams = z.infer<
  typeof labelingStudioSearchSchema
>
